import React, { useEffect, useState } from 'react';

export default function SiteLoader() {
  const [visible, setVisible] = useState(true);
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    let done = false;
    const minDelay = 650;
    const started = Date.now();

    const finish = () => {
      if (done) return;
      done = true;
      const wait = Math.max(0, minDelay - (Date.now() - started));
      window.setTimeout(() => {
        setLeaving(true);
        window.setTimeout(() => setVisible(false), 420);
      }, wait);
    };

    if (document.readyState === 'complete') {
      finish();
    } else {
      window.addEventListener('load', finish, { once: true });
    }

    const failsafe = window.setTimeout(finish, 1800);

    return () => {
      window.removeEventListener('load', finish);
      window.clearTimeout(failsafe);
    };
  }, []);

  if (!visible) return null;

  return (
    <div
      className={`site-loader${leaving ? ' is-leaving' : ''}`}
      aria-busy="true"
      aria-live="polite"
    >
      <div className="site-loader__veil" aria-hidden="true" />
      <div className="site-loader__panel">
        <span className="site-loader__orb" aria-hidden="true" />
        <p className="site-loader__label">Loading</p>
      </div>
    </div>
  );
}
